module.exports = __webpack_public_path__ + "img/prospectorOnboarding.ad5eb97d.gif";